import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import ListExportMenuItem from './ListExportMenuItem';
import { useTranslation } from 'react-i18next';
import ListImportMenuItem from './ListImportMenuItem';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var ListMenu = function (_a) {
    var listTitle = _a.listTitle, onImport = _a.onImport, onExport = _a.onExport, onRestore = _a.onRestore, onTemplate = _a.onTemplate, partialImportOnly = _a.partialImportOnly;
    var t = useTranslation().t;
    var _b = useState(null), menuAnchor = _b[0], setMenuAnchor = _b[1];
    var importEnabled = !!onImport;
    var exportEnabled = !!onExport;
    var handleCloseMenu = function () { return setMenuAnchor(null); };
    var handleRestore = function (event) {
        handleCloseMenu();
        onRestore(event);
    };
    var handleTemplate = function (event) {
        handleCloseMenu();
        onTemplate(event);
    };
    var handleExport = function (settings, event) {
        handleCloseMenu();
        onExport && onExport(settings, event);
    };
    var handleImport = function (settings, event) {
        handleCloseMenu();
        onImport && onImport(settings, event);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: "More options" },
            React.createElement(IconButton, { onClick: function (e) { return setMenuAnchor(e.currentTarget); }, className: "listHeader__menuButton" },
                React.createElement(AccurityIcon, { iconName: "mui:MoreVert" }))),
        React.createElement(Menu, { open: !!menuAnchor, anchorEl: menuAnchor, container: document.getElementById('appContainer'), anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, onClose: handleCloseMenu },
            React.createElement(MenuItem, { onClick: handleRestore }, t('list.restoreSettings')),
            exportEnabled && importEnabled && React.createElement(MenuItem, { onClick: handleTemplate }, t('list.template', { listTitle: listTitle })),
            importEnabled && React.createElement(ListImportMenuItem, { listTitle: listTitle, onClose: handleCloseMenu, onImport: handleImport, partialImportOnly: partialImportOnly }),
            exportEnabled && React.createElement(ListExportMenuItem, { listTitle: listTitle, onClose: handleCloseMenu, onExport: handleExport, importEnabled: importEnabled }))));
};
export default ListMenu;
//# sourceMappingURL=ListMenu.js.map